import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AMap from "AMap"
import VideoPlayer from 'vue-video-player'
import ElementUI from 'element-ui'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import './components/button.css'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(VideoPlayer);
Vue.config.productionTip = false
Vue.prototype.$AMap = AMap
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
